import axios from 'axios';
import { supabase } from '../config/supabase.config';
import { API_URL } from '../config/supabase.config';
import { Lead, LeadFormData, LeadFilters, LeadStats } from '../types/lead.types';

const getAuthHeader = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    headers: {
      Authorization: `Bearer ${session?.access_token}`,
      'Content-Type': 'application/json',
    },
  };
};

export const leadsService = {
  async getLeads(filters?: LeadFilters): Promise<Lead[]> {
    const config = await getAuthHeader();
    const response = await axios.get(`${API_URL}/leads`, {
      ...config,
      params: filters,
    });
    return response.data;
  },

  async getLeadById(id: string): Promise<Lead> {
    const config = await getAuthHeader();
    const response = await axios.get(`${API_URL}/leads/${id}`, config);
    return response.data;
  },

  async createLead(leadData: LeadFormData): Promise<Lead> {
    const config = await getAuthHeader();
    const response = await axios.post(`${API_URL}/leads`, leadData, config);
    return response.data;
  },

  async updateLead(id: string, updates: Partial<LeadFormData>): Promise<Lead> {
    const config = await getAuthHeader();
    const response = await axios.put(`${API_URL}/leads/${id}`, updates, config);
    return response.data;
  },

  async deleteLead(id: string): Promise<void> {
    const config = await getAuthHeader();
    await axios.delete(`${API_URL}/leads/${id}`, config);
  },

  async updateStatus(id: string, status: string): Promise<Lead> {
    const config = await getAuthHeader();
    const response = await axios.patch(
      `${API_URL}/leads/${id}/status`,
      { status },
      config
    );
    return response.data;
  },

  async assignLead(id: string, assignedTo: string): Promise<Lead> {
    const config = await getAuthHeader();
    const response = await axios.patch(
      `${API_URL}/leads/${id}/assign`,
      { assigned_to: assignedTo },
      config
    );
    return response.data;
  },

  async getLeadStats(): Promise<LeadStats> {
    const config = await getAuthHeader();
    const response = await axios.get(`${API_URL}/leads/stats`, config);
    return response.data;
  },

  async bulkUpdateLeads(ids: string[], updates: Partial<LeadFormData>): Promise<void> {
    const config = await getAuthHeader();
    await axios.post(`${API_URL}/leads/bulk-update`, { ids, updates }, config);
  },
};
